module.exports = __webpack_public_path__ + "static/Strato-f6a25ddaedbcbf67c16c4777b08e196f.svg";